import { X_COUNTRY_CODE } from '@/constants/headers';
import { SERVERSIDE_getSearchParams } from '@/modules/headers/SERVERSIDE_getSearchParams';

const headers = import('next/headers');

/**
 * Gets the country code for server-side requests
 */
export async function SERVERSIDE_getCountryCode(): Promise<string> {
  const headersFunction = await headers;
  const params = await SERVERSIDE_getSearchParams();

  return (
    params.country_code ||
    (await headersFunction.headers()).get(X_COUNTRY_CODE) ||
    'US'
  );
}
